export const EXPIRED_ACTION_NOTICE = '本次操作已过期，请重新发起。';

// Count only rows actually present after the existing merge/deduplication; never infer matches.
export function listSummary(items, matchedTotal) {
  const loaded = Array.isArray(items) ? items.length : 0;
  return Number.isInteger(matchedTotal)
    ? `匹配 ${matchedTotal} 项 · 已加载 ${loaded} 项`
    : `已加载 ${loaded} 项`;
}

// A server read error takes precedence while retry is available. Loading/retry controls remain local.
export function listNotice(card, pagination = {}) {
  return typeof pagination.errorMessage === 'string' && pagination.errorMessage.trim()
    ? pagination.errorMessage : typeof card.notice === 'string' ? card.notice : '';
}
